import type { PaymentMethod, WorkPayment } from "../api";

export type WorkPaymentLine = { method: PaymentMethod; amount: string };

export function persistedPaidTotal(payments: WorkPayment[]): string {
  return String(payments.reduce((sum, payment) => sum + Number(payment.summa), 0));
}

export function displayedSingleAmount(
  lines: WorkPaymentLine[],
  total: number,
  touched: boolean,
): string {
  return lines.length === 1 && !touched
    ? (total ? String(total) : "")
    : lines[0]?.amount ?? "";
}

export function aggregatePaid(
  lines: WorkPaymentLine[],
  total: number,
  touched: boolean,
): number {
  if (lines.length === 1) {
    return Number(displayedSingleAmount(lines, total, touched)) || 0;
  }
  return lines.reduce((sum, line) => sum + (Number(line.amount) || 0), 0);
}

export function invalidPaymentLines(lines: WorkPaymentLine[]): boolean {
  return lines.length > 1
    && lines.some((line) => !line.amount || Number(line.amount) <= 0);
}

export function togglePaymentLine(
  lines: WorkPaymentLine[],
  method: PaymentMethod,
  total: number,
  touched: boolean,
): WorkPaymentLine[] {
  if (lines.some((line) => line.method === method)) {
    return lines.filter((line) => line.method !== method);
  }
  const materialized = lines.length === 1 && !touched
    ? [{ ...lines[0], amount: total ? String(total) : "" }]
    : lines;
  return [...materialized, { method, amount: "" }];
}

export function paymentPayload(
  lines: WorkPaymentLine[],
  total: number,
  touched: boolean,
) {
  const single = displayedSingleAmount(lines, total, touched);
  return lines.flatMap((line) => {
    const amount = lines.length === 1 ? Number(single) : Number(line.amount);
    return amount > 0 ? [{ tolov_usuli: line.method, summa: String(amount) }] : [];
  });
}
